/* istanbul ignore file */
import createLogger from './createLogger';
export default createLogger;
//# sourceMappingURL=index.js.map